import ApisService from './index'
import {
  IRequestPaymentAdd,
  IRequestPaymentUpdate,
} from '../interfaces/requestPaymentInterfaces'
import { handleError } from '../utils/commonUtils'
import * as queryString from 'query-string'

export function createRequestPayment(data: IRequestPaymentAdd) {
  try {
    return ApisService.post('/yeucauthanhtoan/create-yeucauthanhtoan', data)
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function updateRequestPayment(data: IRequestPaymentUpdate) {
  try {
    return ApisService.put('/yeucauthanhtoan/' + data.id + '/update-yeucauthanhtoan', data)
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function getDetailRequestPayment(id: string) {
  try {
    return ApisService.get('/yeucauthanhtoan/' + id + '/get-chitiet-yeucauthanhtoan')
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function getListRequestPayment(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisService.get('/yeucauthanhtoan/filter-yeucauthanhtoan', {
      params: query || {},
    })
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function deleteRequestPayment(id: string) {
  try {
    return ApisService.delete('/yeucauthanhtoan/' + id + '/delete-yeucauthanhtoan')
  } catch (err) {
    handleError(err)
    throw err
  }
}
